module.exports = __webpack_public_path__ + "static/media/bank-brex.e60fe86f.svg";